import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-coordination-study-check-box-cell-renderer',
    imports: [MatCheckboxModule, FormsModule, ReactiveFormsModule],
    templateUrl: './coordination-study-check-box-cell-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class CoordinationStudyCheckBoxCellRendererComponent
    implements ICellRendererAngularComp
{
    formControl: FormControl | null = null;

    agInit(params: ICellRendererParams): void {
        const getFormGroupForStudy =
            params.colDef?.cellRendererParams?.getFormGroupForStudy;
        const studyId = params.data?.id;

        if (getFormGroupForStudy && studyId !== undefined) {
            const formGroup = getFormGroupForStudy(studyId);
            this.formControl = formGroup?.get(
                params.column?.getColId(),
            ) as FormControl;
        }
    }

    refresh(): boolean {
        return false;
    }
}
